"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getAddToCartTemplate = function getAddToCartTemplate() {
  return {
    productListAdds: {
      value: 1
    },
    productListOpens: {
      value: 1
    }
  };
};
var _default = exports["default"] = getAddToCartTemplate;